// import { useTranslation } from 'react-i18next';

export const genreTitres = [
    {
        value: 'mr',
        label: 'Mr',
    },
    {
        value: 'mme',
        label: 'Mme',
    }];
export const expertTypeEsn = [
    {
        value: 'indep',
        label: 'Indépendant',
    },
    {
        value: 'salarie',
        label: 'Salarié',
    }];

export const typeDemande = [
    {
        value: 'demo',
        label: 'Une démo',
    },
    {
        value: 'information',
        label: 'Une information',
    }];

export const typeExperts = [
    {
        value: 'candidat',
        label: 'Dossier candidat',
    },
    {
        value: 'expert',
        label: 'Expert',
    }];

export const statutDocAdministratifsClient = [
    {
        value: 'valide',
        label: 'Validé',
    },
    {
        value: 'expire',
        label: 'Expiré',
    },
    {
        value: 'encours',
        label: 'En attente de validation',
    },
    {
        value: 'rejete',
        label: 'Rejeté',
    }
];
export const fluxCandidature = [
    {
        value: 'ao',
        label: 'AO',
    },
    {
        value: 'cvtheque',
        label: 'CVThèque-AO',
    },
    {
        value: 'dossier',
        label: 'CVThèque',
    }
];
export const candidatureStatus = [
    {
        value: 'unread',
        label: 'Non lue',
    },
    {
        value: 'analyzed',
        label: 'Lue',
    },
    {
        value: 'checkDispo',
        label: 'Dispo. à vérifier',
    },
    {
        value: 'interesting',
        label: 'Intéressante',
    },
    {
        value: 'interview',
        label: 'À interviewer',
    },
    {
        value: 'rejected',
        label: 'Non Retenue',
    },
    {
        value: 'retained',
        label: 'Retenue',
    },
    {
        value: 'converted',
        label: 'Mission créée',
    },
];

export const taskModalProgressEnum=[
    {
        value:'To do',
        label:'To do',
    },
    {
        value:'in progress',
        label:'In progress',
    },
    {
        value:'done',
        label:'Done',
    },
];

// c'est le premier BDC
export const dureeBdcEnum = [
    {
        value: '1',
        label: '1 mois'
    },
    {
        value: '3',
        label: '3 mois'
    },
    {
        value: '6',
        label: '6 mois'
    },
    {
        value: '12',
        label: '12 mois'
    },
];

export const urlListeSideBar=[
    {
        value: '/client/donneesGenerales',
        label: 'Profil entreprise'
    },
    {
        value: '/client/donneesFacturation',
        label: 'Données Facturation'
    },
    {
        value: '/client/donneesPC',
        label: 'Données PC'
    }
];

export const urlListeSideBarExpert=[
    {
        value: '/expert/donneeProfile',
        label: 'Profil personnel'
    },
    {
        value: '/expert/donneeProfile/donneesCV',
        label: 'Données CV'
    },
    {
        value: '/expert/donneeProfile/preferences',
        label: 'Préférences'
    },
    {
        value: '/expert/donneeProfile/societe',
        label: 'Société'
    }
];

export const urlListeSideBarDocAdministraExpert=[
    {
        value: '/expert/docAdministrative',
        label: 'Pièce d\'identité'
    },
    {
        value: '/expert/docAdministrative/kbis',
        label: 'Kbis'
    },

    {
        value: '/expert/docAdministrative/attestationUrssaf',
        label: 'Attestation Urssaf'
    },

    {
        value: '/expert/docAdministrative/assurance',
        label: 'Assurance'
    },
    {
        value: '/expert/docAdministrative/attestationFiscale',
        label: 'Attestation fiscale'
    },
    {
        value: '/expert/docAdministrative/contratHTH',
        label: 'Contrat'
    },
    {
        value: '/expert/docAdministrative/attestationHonneur',
        label: 'Attestation sur l\'honneur'
    }
];

export const dureeMissionFiltre = [
    {
        value: '30',
        label: '1 mois'
    },
    {
        value: '90',
        label: '3 mois'
    },
    {
        value: '180',
        label: '6 mois'
    },
    {
        value: '360',
        label: '> 12 mois'
    },
];
//'1', '3','6','12'

export const delaiPaiementList =[
    {
        value:'30',
        label:'30 jours',
    },
    {
        value:'45',
        label:'45 jours',
    },
    {
        value:'60',
        label:'60 jours',
    },
];

export const statuColab=[
    {
        value:'Actif',
        label:'Actif',
    },
    {
        value:'Inv',
        label:'Invitation en attente',
    },
    {
        value:'Avalider',
        label:'A valider',
    },
];

export const sourceMissionEnum =[
    {
        value:'ao',
        label:'Appel d\'offres',
    },
    {
        value:'cvtheque',
        label:'CVthèque',

    }
];
export const taskModalPriorityEnum=[
    {
        value:'high',
        label:'high',
    },
    {
        value:'low',
        label:'low',
    },
    {
        value:'medium',
        label:'medium',
    }
];

export const PeriodeDashboard =[
    {
        value:'thisWeek',
        label:'Cette semaine',
    },
    {
        value:'twoPrevWeeks',
        label:'Deux semaines',
    },
    {
        value:'thisMonth',
        label:'Ce mois-ci',
    },
    {
        value:'custom',
        label:'Custom',
        hidden: true, // Add a hidden property to the item
    },
];

export const PeriodeEchancier =[
    {
        value:'custom',
        label:'Custom',
        hidden: true, // Add a hidden property to the item
    },
];

export const PeriodeDashboardListFtrCra =[
    {
        value:'thisMonth',
        label:'Ce mois-ci',
    },
    {
        value:'custom',
        label:'Custom',
        hidden: true, // Add a hidden property to the item
    },
];

export const StatusAODashboardBO =[
    {
        value:'notEqZero',
        label:'AO avec candidature',
    },
    {
        value:'all',
        label:'Toutes les candidatures',
    },
];

export const typeDocument =[
    {
        value:'kbis',
        label:'Kbis',
    },
    {
        value:'cv',
        label:'CV',
    },
    {
        value:'passeport',
        label:'Passeport',
    },
    {
        value:'cinRecto',
        label:'CIN',
    },
    {
        value:'contrat',
        label:'Contrat',
    },
    {
        value:'assurance',
        label:'Assurance',
    },
    {
        value:'attestationFiscale',
        label:'Attestation fiscale',
    },
    {
        value:'attestationURSSAF',
        label:'Attestation URSSAF',
    },
    {
        value:'attestationHonneur',
        label:'Attestation honneur',
    },
];

export const typesContratEnum =[
    {
        value:'CDI',
        label:'CDI',

    },
    {
        value:'CDD',
        label:'CDD',

    },
    {
        value:'CTT',
        label:'CTT',

    },
    {
        value:'Freelance',
        label:'Freelance',
    },
    {
        value:' ',//* espace est la valeur du vide
        label:'Autre',
    },
];

export const experienceTotal = [
    {
        value: '1',
        label: '1 an',
    },
    {
        value: '2',
        label: '2 ans',
    },
    {
        value: '3',
        label: '3 ans',
    },
    {
        value: '4',
        label: '4 ans',
    },
    {
        value: '5',
        label: '5 ans',
    },
    {
        value: '10',
        label: '10 ans',
    },
    //{
    //    value:'-',
    //    label:'Autre',
    //},
];

export const rdvStatus = [
    {
        value: 'planifie',
        label: 'En attente d\'acceptation',
    },
    {
        value: 'replanifie',
        label: 'Replanifié',
    },
    {
        value: 'accepte',
        label: 'Accepté',
    },
    {
        value: 'rejete',
        label: 'rejeté',
    },
    {
        value: 'annule',
        label: 'annulé',
    }
];

export const rdvStatusEnum = {
    planifie: 'planifie',
    replanifie: 'replanifie',
    accepte: 'accepte',
    rejete: 'rejete',
    annule: 'annule'
};

export const EmplacementEnum = [
    {
        value: 'audioConference',
        label: 'Audio-conférence',
    },
    {
        value: 'visioConference',
        label: 'Visio-conférence',
    },
    {
        value: 'surPlace',
        label: 'Sur site',
    },
];

export const foncSkillSet = [
    { title: 'Résolution de problèmes' },
    { title: 'Analyse des données' },
    { title: 'Planification stratégique' },
    { title: 'Gestion du temps' },
    { title: 'Esprit d\'équipe' },
    { title: 'Leadership' },
    { title: 'Prise de décision' },
    { title: 'Créativité' },
    { title: 'Adaptabilité' },
    { title: 'Organisation d\'événements' },
    { title: 'Négociation' },
    { title: 'Relations interpersonnelles' },
    { title: 'Gestion du stress' },
    { title: 'Développement de produits' },
    { title: 'Conception UX/UI' },
    { title: 'Formation' },
    { title: 'Agile' },
    { title: 'Planification de projet' },
    { title: 'Facilitation de réunions' },
    { title: 'Rédaction technique' },
    { title: 'Évaluation des performances' },
    { title: 'Développement professionnel' },
    { title: 'Service client' },
    { title: 'Écoute active' },
    { title: 'Conception de présentations' },
    { title: 'Optimisation des processus' },
    { title: 'Gestion des conflits' },
    { title: 'Marketing' },
    { title: 'Stratégie de marque' },
    { title: 'Recherche de marché' },
    { title: 'Présentation orale' },
    { title: 'Gestion de projet' },
    { title: 'Esprit analytique' },
    { title: 'Travail d\'équipe' },
    { title: 'Planification financière' },
    { title: 'Gestion des relations clients' },
    { title: 'Communication efficace' },
    { title: 'Réflexion critique' },
    { title: 'Formation en ligne' },
    { title: 'Gestion de la qualité' },
    { title: 'Évaluation des besoins' },
    { title: 'Coordination d\'événements' },
    { title: 'Résolution de conflits' },
    { title: 'Conseil en stratégie' },
    { title: 'Gestion de la chaîne logistique' },
    { title: 'Planification opérationnelle' },
    { title: 'Esprit d\'entreprise' },
    { title: 'Conception de processus' },
    { title: 'Gestion des ressources' },
    { title: 'Évaluation des risques' },
    { title: 'Conformité réglementaire' },
    { title: 'Développement durable' },
    { title: 'Conception d\'expérience utilisateur' },
    { title: 'Gestion de crise' },
    { title: 'Élaboration de politiques' },
    { title: 'Audit' },
    { title: 'Recrutement' },
    { title: 'Planification de carrière' },
    { title: 'Développement de partenariats' },
    { title: 'Gestion de la diversité' },
    { title: 'Innovation' },
    { title: 'Sens du détail' },
    { title: 'Gestion des technologies de l\'information' },
    { title: 'Rédaction de propositions' },
    { title: 'Planification stratégique des médias sociaux' },
    { title: 'Formation en leadership' },
    { title: 'Évaluation de la performance des employés' },
    { title: 'Gestion des talents' },
    { title: 'Éthique professionnelle' },
    { title: 'Gestion de programme' },
    { title: 'Responsabilité sociale des entreprises' },
    { title: 'Coaching' },
    { title: 'Gestion des connaissances' },
    { title: 'Planification des ressources humaines' },
    { title: 'Gestion de la chaîne d\'approvisionnement' },
    { title: 'Élaboration de stratégies de vente' },
    { title: 'Marketing digital' },
    { title: 'Conception de produits' },
    { title: 'Gestion de la performance organisationnelle' },
    { title: 'Planification événementielle' },
    { title: 'Gestion de l\'innovation' },
    { title: 'Gestion de la sécurité de l\'information' },
    { title: 'Analyse de rentabilisation' },
    { title: 'Gestion de la formation' },
    { title: 'Gestion de la continuité des activités' },
    { title: 'Stratégie de communication' },
    { title: 'Résolution de problèmes complexes' },
];

// Enums

export const plusRecenteExperience = [

    {
        value: 'cetteAnnee',
        label: 'Cette année',
    },
    {
        value: '1a2',
        label: '1 à 2ans',
    },
    {
        value: 'plus2ans',
        label: 'Plus de 2 ans',
    },
];

export const niveauxSkill = [
    {
        value: 'debutant',
        label: 'Débutant',
    },
    {
        value: 'intermediaire',
        label: 'Confirmé',
    },
    {
        value: 'avance',
        label: 'Senior',
    },
    {
        value: 'expert',
        label: 'Expert',
    },
];

export const niveauxSkillAo = [
    //masquer pour l'expert dans la partie donnee CV partage // afficher pour client dans AO
    {
        value: 'indifferent',
        label: 'Indifférent',
    },
    {
        value: 'debutant',
        label: 'Débutant',
    },
    {
        value: 'intermediaire',
        label: 'Confirmé',
    },
    {
        value: 'avance',
        label: 'Senior',
    },
    {
        value: 'expert',
        label: 'Expert',
    },
];

export const niveauxLangue = [
    {
        value: 'notion',
        label: 'Notions',
    },

    {
        value: 'professionnel',
        label: 'Professionnel',
    },
    {
        value: 'avance',
        label: 'Avancé',
    },
    {
        value: 'bilingue',
        label: 'Courant',
    },
];

export const exigencesEnum = [
    {
        value: 'exige',
        label: 'Exigé',
    },
    {
        value: 'recommende',
        label: 'Recommandé',
    },
];

export const modeTravailEnum = [
    {
        value: 'remote',
        label: 'A distance',
    },
    {
        value: 'presentiel',
        label: 'Présentiel',
    },
    {
        value: 'hybride',
        label: 'Hybride',
    },
    {
        value: 'indifferent',
        label: 'Indifférent',
    },
];
export const regimeTravailEnum = [
    {
        value: 'temps-plein',
        label: 'Temps plein',
    },
    {
        value: 'temps-partiel',
        label: 'Temps partiel',
    },
];

export const isMontantOrCoeff = [
    {
        value: 'Montant',
        label: 'Montant',
    },
    {
        value: 'Coefficient',
        label: 'Coefficient',
    },
];

export const typeDiplomeEnum = [
    {
        value: 'ecoleElementaire',
        label: 'Ecole élémentaire',
    },
    {
        value: 'diplomeNationalBrevet',
        label: 'Diplôme national du brevet',
    },
    {

        value: 'capBep',
        label: 'CAP/BEP',
    },
    {
        value: 'baccalaureat',
        label: 'Baccalauréat',
    },
    {
        value: 'btsDut',
        label: 'BTS/DUT',
    },
    {
        value: 'licencePro',
        label: 'Licence /Licence professionnelle',
    },
    {
        value: 'master',
        label: 'Master/Titre d\'ingénieur',
    },
    {
        value: 'doctorat',
        label: 'Doctorat',
    },
];

export const conditionPaiement=[
    {
        value: 'virement',
        label: 'Par virement',
    },
];

export const laguesFacturation = [
    {
        value: 'francais',
        label: 'Français'
    },
    //{
    //    value: 'anglais',
    //    label: 'Anglais'
    //},
];

// * this array contains all languages in the world
export const languesList = [
    {
        value: 'English',
        label: 'Anglais'
    },
    {
        value: 'Spanish',
        label: 'Espagnol'
    },
    {
        value: 'azerbaijani',
        label: 'Azerbaijani'
    },

    {
        value: 'French',
        label: 'Français'
    },
    {
        value: 'Mandarin',
        label: 'Mandarin'
    },
    {
        value: 'Arabic',
        label: 'Arabe'
    },
    {
        value: 'Russian',
        label: 'Russe'
    },
    {
        value: 'Hindi',
        label: 'Hindi'
    },
    {
        value: 'Bengali',
        label: 'Bengali'
    },
    {
        value: 'Portuguese',
        label: 'Portugais'
    },
    {
        value: 'Indonesian',
        label: 'Indonésien'
    },
    {
        value: 'German',
        label: 'Allemand'
    },
    {
        value: 'Japanese',
        label: 'Japonais'
    },
    {
        value: 'Korean',
        label: 'Coréen'
    },
    {
        value: 'Turkish',
        label: 'Turc'
    },
    {
        value: 'Vietnamese',
        label: 'Vietnamien'
    },
    {
        value: 'Italian',
        label: 'Italien'
    },
    {
        value: 'Dutch',
        label: 'Néerlandais'
    },
    {
        value: 'Polish',
        label: 'Polonais'
    },
    {
        value: 'Persian',
        label: 'Persan'
    },
    {
        value: 'Ukrainian',
        label: 'Ukrainien'
    },
    {
        value: 'Romanian',
        label: 'Roumain'
    },
    {
        value: 'Czech',
        label: 'Tchèque'
    },
    {
        value: 'Hungarian',
        label: 'Hongrois'
    },
    {
        value: 'Swedish',
        label: 'Suédois'
    },
    {
        value: 'Danish',
        label: 'Danois'
    },
    {
        value: 'Norwegian',
        label: 'Norvégien'
    },
    {
        value: 'Finnish',
        label: 'Finnois'
    },
    {
        value: 'Slovak',
        label: 'Slovaque'
    },
    {
        value: 'Croatian',
        label: 'Croate'
    },
    {
        value: 'Serbian',
        label: 'Serbe'
    },
    {
        value: 'Bulgarian',
        label: 'Bulgare'
    },
    {
        value: 'Greek',
        label: 'Grec'
    },
    {
        value: 'Hebrew',
        label: 'Hébreu'
    },
    {
        value: 'Thai',
        label: 'Thaï'
    },
    {
        value: 'Khmer',
        label: 'Khmer'
    },
    {
        value: 'Lao',
        label: 'Lao'
    },
    {
        value: 'Burmese',
        label: 'Birman'
    },
    {
        value: 'Tamil',
        label: 'Tamoul'
    },
    {
        value: 'Telugu',
        label: 'Télougou'
    },
    {
        value: 'Marathi',
        label: 'Marathe'
    },
    {
        value: 'Gujarati',
        label: 'Gujarati'
    },
    {
        value: 'Punjabi',
        label: 'Pendjabi'
    },
    {
        value: 'Kannada',
        label: 'Kannada'
    },
    {
        value: 'Oriya',
        label: 'Oriya'
    },
    {
        value: 'Malayalam',
        label: 'Malayalam'
    },
    {
        value: 'Sinhala',
        label: 'Cingalais'
    },
    {
        value: 'Assamese',
        label: 'Assamais'
    },
    {
        value: 'Nepali',
        label: 'Népalais'
    },
    {
        value: 'Urdu',
        label: 'Ourdou'
    },
    {
        value: 'Bhojpuri',
        label: 'Bhojpuri'
    },
    {
        value: 'Hausa',
        label: 'Haoussa'
    },
    {
        value: 'Igbo',
        label: 'Igbo'
    },
    {
        value: 'Yoruba',
        label: 'Yoruba'
    },
    {
        value: 'Twi',
        label: 'Twi'
    },
    {
        value: 'Akan',
        label: 'Akan'
    },
    {
        value: 'Somali',
        label: 'Somali'
    },
    {
        value: 'Amharic',
        label: 'Amharique'
    },
    {
        value: 'Tigrinya',
        label: 'Tigrigna'
    },
    {
        value: 'Oromo',
        label: 'Oromo'
    },
    {
        value: 'Kiswahili',
        label: 'Swahili'
    },
    {
        value: 'Luganda',
        label: 'Luganda'
    },
    {
        value: 'Shona',
        label: 'Shona'
    },
    {
        value: 'Zulu',
        label: 'Zoulou'
    }
];

export const AjoutDeduire=[
    {
        value: 'ajouter',
        label: 'Ajouter'
    },
    {
        value: 'deduire',
        label: 'Déduire'
    },
];

export const MonthsString=[
    {
        value: '1',
        label: 'Janvier'
    },
    {
        value: '2',
        label: 'Février'
    },
    {
        value: '3',
        label: 'Mars'
    },
    {
        value: '4',
        label: 'Avril'
    },
    {
        value: '5',
        label: 'Mai'
    },
    {
        value: '6',
        label: 'Juin'
    },
    {
        value: '7',
        label: 'Juillet'
    },
    {
        value: '8',
        label: 'Août'
    },
    {
        value: '9',
        label: 'Septembre'
    },
    {
        value: '10',
        label: 'Octobre'
    },
    {
        value: '11',
        label: 'Novembre'
    },
    {
        value: '12',
        label: 'Décembre'
    },
];

export const RolesCollab=[
    {
        value: 'littleAdmin',
        label: 'Admin',
    },
    {
        value: 'Admin',
        label: 'Admin',
    },
    {
        value: 'Rh',
        label: 'RH',
    },
    {
        value: 'Commercial',
        label: 'Commercial',
    },
    {
        value: 'ResponsableAchat',
        label: 'Responsable achat',
    },
    {
        value: 'Manager',
        label: 'Responsable opérationnel',
    },
    {
        value: 'Comptable',
        label: 'Comptable',
    },
];

export const RolesBackOffice=[
    {
        value: 'littleAdmin',
        label: 'Admin',
    },
    {
        value: 'Admin',
        label: 'Admin',
    },
    {
        value: 'chargeRecrutement',
        label: 'Chargé de Recrutement',
    },
    {
        value: 'Comptable',
        label: 'Comptable',
    },
];

export const Fournisseur={
    nomConsultant:'CONSULTANT NICKEL',
    chargeRecrutement:'S.BENGOURRAM',
    societe:'High Tech Hires',
    adresse: 'Lot Al Wakala 1 Bloc E N°527 1er Etg',
    ville:'70000 Laayoune Maroc',
    email:'s.bengourram@datadelegates.com',
    tele:'06 61 97 69 62',
    siret:'42199',
    notva:'52549656',
};

//export async function getFormattedDate(pays) {
//    let locale;
//    switch (pays.toLowerCase()) {
//    case 'fr':
//        locale = await import('dayjs/locale/fr');
//        break;
//    case 'be':
//        locale = await import('dayjs/locale/nl-be');
//        break;
//    case 'ma':
//        locale = await import('dayjs/locale/ar-ma');
//        break;
//    default:
//        locale = await import('dayjs/locale/en');
//    }
//    return locale.default; // Return the default property of the dynamically imported module
//}

export const getFournisseurInfo = (email) => {
    if (email && email.toLowerCase() === ('Bo_Belgique@datadelegates.com').toLowerCase()) {
        return {
            nomConsultant: 'NICKEL',
            chargeRecrutement: 'S.ABAID',
            societe: 'High Tech Hires Belgique',
            adresse: '74 Place du Dr Félix Lobligeois',
            ville:'75017 Paris France',
            email: 's.bengourram@datadelegates.com',
            tele: '01 47 25 34 17',
            siret: '818239873000162',
            notva: 'FER92818239873',
        };
    } else {
        return Fournisseur;
    }
};

export const AdminDataDelegates={
    email:'admin@hightechhires.com',
    tele:'06 61 97 69 62',
};

export const StatutsOrdreMision=[
    {
        value: 'aValider',
        label: 'En cours',
    },
    {
        value: 'signe',
        label: 'Validé',
    },
    {
        value: 'rejete',
        label: 'Rejeté',
    },
];

export const EnCoursString ='En cours';
export const StatutsMisionEnum=[
    {
        value: 'encours',
        label: EnCoursString, //! ne change pas cette label car c'est liee avec getStatutMissionEncourCaseWithDateNotStartingYet
    },
    {
        value: 'interompu',
        label: 'Interrompue',
    },
    {
        value: 'terminee',
        label: 'Terminée',
    },
    {
        value: 'aVenir',
        label: 'En attente de validation',//À venir
    },
    {
        value: 'annulee',
        label: 'Annulée',
    },
    {
        value: 'interruptionEnCours',
        label: 'Interruption en cours',
    },
    {
        value: '',
        label: 'Aucune',
    },
];

export const statutPaiementEnum=[
    {
        value:'paye',
        label:'Payé',
    },
    {
        value:'nonPaye',
        label:'Non payé'
    }
];

export const StatutFacture=[
    {
        value:'genere',
        label:'Généré',
    },
    {
        value:'groupeG',
        label:'Généré-G',
    },
    {
        value:'proformat',
        label:'Proforma'
    },
    {
        value:'groupe',
        label:'Généré-G'
    }
];

export const StatutDosier=[
    {
        value:'encours',
        label:'En cours',
    },
    {
        value:'cloture',
        label:'Clôturé'
    }
];

export const StatutCollabClient=[
    {
        value:'aValider',
        label:'à valider',
    },
    {
        value:'actif',
        label:'Actif',
    },
    {
        value:'enAttente',
        label:'En attente'
    }
];
export const StatutCollabBackOffice=[
    {
        value:'actif',
        label:'Actif',
    },
    {
        value:'enAttente',
        label:'En attente'
    }
];
export const sideBarGestionExpert=[
    {
        value:'/admin/gestionExperts/646220c29953fc29e78b89d0/DonneePersonnel',
        label:'Données profil',
    },
    {
        value:'/admin/gestionExperts/646220c29953fc29e78b89d0/PieceIdentite',
        label:'Documents administratifs',
    }
];

export const statutDocAdministratifs = [
    {
        value: 'encours',
        label: 'En cours',
    },
    {
        value: 'valide',
        label: 'Validé',
    },
    {
        value: 'rejete',
        label: 'Rejeté',
    },
    {
        value: 'expire',
        label: 'Expiré',
    },
];

export const genreList = [
    {
        value: 'mme',
        label: 'Mme',
    },
    {
        value: 'mr',
        label: 'Mr',
    }
];

export const allSubCategories = 'Toutes les sous catégories';
export const categories = [
    {
        value: 'Digital',
        label: 'Digital',
        sousCategories: [
            {
                value: 'allSubCategoriesDigital',
                label: `Digital/${allSubCategories}`
            }
            ,
            {
                value: 'Front End Developers',
                label: 'Front End Developers'
            }
            ,
            {
                value: 'Back End Developers',
                label: 'Back End Developers'
            }
            ,
            {
                value: 'Full stack Developers',
                label: 'Full stack Developers'
            }
            ,
            {
                value: 'Apps & Mobile Developers',
                label: 'Apps & Mobile Developers'
            }
            ,
            {
                value: 'Web Developers',
                label: 'Web Developers'
            }
            ,
            {
                value: 'Software Developers',
                label: 'Software Developers'
            }
            ,
            {
                value: 'Project managers',
                label: 'Project managers'
            }
            ,
            {
                value: 'Scrum masters',
                label: 'Scrum masters'
            }
            ,
            {
                value: 'Product owners',
                label: 'Product owners'
            }
            ,
            {
                value: 'PMI Project managers',
                label: 'PMI Project managers'
            }

            ,
            {
                value: 'PMO Specialists',
                label: 'PMO Specialists'
            }
            ,
            {
                value: 'Scrum coaches',
                label: 'Scrum coaches'
            }
            ,
            {
                value: 'UI & UX designers',
                label: 'UI & UX designers'
            }
            ,
            {
                value: 'Web Designers',
                label: 'Web Designers'
            }
            ,
            {
                value: 'Web / Digital marketings',
                label: 'Web / Digital marketings'
            }

            ,
            {
                value: 'Tech lead',
                label: 'Tech lead'
            }
            ,
            {
                value: 'Testing',
                label: 'Testing'
            }
            ,
            {
                value: 'Others',
                label: 'Others'
            }

        ],
    },
    {
        value: 'Big data',
        label: 'Big data',
        sousCategories: [
            {
                value: 'allSubCategoriesBigData',
                label: `Big data/${allSubCategories}`
            }
            ,
            {
                value: 'Data Engineers',
                label: 'Data Engineers'
            }
            ,
            {
                value: 'Data Scientists',
                label: 'Data Scientists'
            }
            ,
            {
                value: 'Business Analyst',
                label: 'Business Analyst'
            }
            ,
            {
                value: 'Data Analysts',
                label: 'Data Analysts'
            }
            ,
            {
                value: 'Big Data Architects',
                label: 'Big Data Architects'
            }
            ,
            {
                value: 'Big Data Developers',
                label: 'Big Data Developers'
            }
            ,
            {
                value: 'Big Data Administrators',
                label: 'Big Data Administrators'
            }
            ,
            {
                value: 'Master data Managers',
                label: 'Master data Managers'
            }
            ,
            {
                value: 'Business Intelligence consultants',
                label: 'Business Intelligence consultants'
            }
            ,
            {
                value: 'Big Data Visualizers',
                label: 'Big Data Visualizers'
            }
            ,
            {
                value: 'Data Modelers',
                label: 'Data Modelers'
            }
            ,
            {
                value: 'Data base Administrators',
                label: 'Data base Administrators'
            }
            ,
            {
                value: 'Others',
                label: 'Others'
            }
            ,
        ],
    },
    {
        value: 'Infrastructures',
        label: 'Infrastructures',
        sousCategories: [
            {
                value: 'allSubCategoriesInfrastructure',
                label: `Infrastructures/${allSubCategories}`
            }
            ,
            {
                value: 'Infrastructure architect ',
                label: 'Infrastructure architect '
            }
            ,
            {
                value: 'Computer park managers ',
                label: 'Computer park managers '
            }
            ,
            {
                value: 'IT production engineers ',
                label: 'IT production engineers '
            }
            ,
            {
                value: 'Methods / IT quality engineers ',
                label: 'Methods / IT quality engineers '
            }
            ,
            {
                value: 'System Engineers ',
                label: 'System Engineers '
            }
            ,
            {
                value: 'Infrastructure and IT Production Directors ',
                label: 'Infrastructure and IT Production Directors '
            }
            ,
            {
                value: 'Database Administrators ',
                label: 'Database Administrators '
            }
            ,
            {
                value: 'Network/telecom engineers',
                label: 'Network/telecom engineers'
            }
            ,
            {
                value: 'Others',
                label: 'Others'
            }
            ,
        ],
    },
    {
        value: 'SAP',
        label: 'SAP',
        sousCategories: [
            {
                value: 'allSubCategoriesSAP',
                label: `SAP/${allSubCategories}`
            }
            ,
            {
                value: 'SAP Consultants ',
                label: 'SAP Consultants '
            }
            ,
            {
                value: 'SAP QM Consultants ',
                label: 'SAP QM Consultants '
            }
            ,
            {
                value: 'SAP TM Consultants ',
                label: 'SAP TM Consultants '
            }
            ,
            {
                value: 'SAP HANA Consultants ',
                label: 'SAP HANA Consultants '
            }
            ,
            {
                value: 'SAP BI Consultants',
                label: 'SAP BI Consultants'
            }
            ,
            {
                value: 'SAP BW Consultants ',
                label: 'SAP BW Consultants '
            }
            ,
            {
                value: 'SAP BASIS Consultants ',
                label: 'SAP BASIS Consultants '
            }
            ,
            {
                value: 'SAPUI5 Consultants ',
                label: 'SAPUI5 Consultants '
            }
            ,
            {
                value: 'SAP NetWeaver Consultants  ',
                label: 'SAP NetWeaver Consultants  '
            }
            ,
            {
                value: 'SAP Fiori Consultants ',
                label: 'SAP Fiori Consultants '
            }
            ,
            {
                value: 'Business Object ',
                label: 'Business Object Consultants '
            }
            ,
            {
                value: 'SAP Crystal Report Consultants ',
                label: 'SAP Crystal Report Consultants '
            }
            ,
            {
                value: 'SAP Solution Manager Consultants ',
                label: 'SAP Solution Manager Consultants '
            }
            ,
            {
                value: 'SAP Script Consultants ',
                label: 'SAP Script Consultants '
            }
            ,
            {
                value: 'SAP Hybris Consultants ',
                label: 'SAP Hybris Consultants '
            }
            ,
            {
                value: 'SAP Ariba Consultants ',
                label: 'SAP Ariba Consultants '
            }
            ,
            {
                value: 'SAP FICO Consultants ',
                label: 'SAP FICO Consultants '
            }
            ,
            {
                value: 'SAP HR Consultants ',
                label: 'SAP HR Consultants '
            }
            ,
            {
                value: 'SAP SD-MM Consultants ',
                label: 'SAP SD-MM Consultants '
            }
            ,
            {
                value: 'SAP CRM Consultants ',
                label: 'SAP CRM Consultants '
            }
            ,
            {
                value: 'SAP ERP Consultants ',
                label: 'SAP ERP Consultants '
            }
            ,

            {
                value: 'ABAP  Consultants',
                label: 'ABAP  Consultants'
            }
            ,
            {
                value: 'Others',
                label: 'Others'
            }
            ,
        ],
    },
    {
        value: 'Cloud',
        label: 'Cloud',
        sousCategories: [
            {
                value: 'allSubCategoriesCloud',
                label: `Cloud/${allSubCategories}`
            }
            ,
            {
                value: 'Cloud Administrators ',
                label: 'Cloud Administrators '
            }
            ,
            {
                value: 'Cloud Architects ',
                label: 'Cloud Architects '
            }
            ,
            {
                value: 'Cloud consultants ',
                label: 'Cloud consultants '
            }
            ,
            {
                value: 'Others',
                label: 'Others'
            }
            ,
        ],
    },
    {
        value: 'DevOps',
        label: 'DevOps',
        sousCategories: [
            {
                value: 'allSubCategoriesDevops',
                label: `DevOps/${allSubCategories}`
            }
            ,
            {
                value: 'Devops Engineer',
                label: 'Devops Engineer'
            }
            ,
            {
                value: 'DevSecOps',
                label: 'DevSecOps'
            }
            ,
            {
                value: 'Others',
                label: 'Others'
            }
            ,

        ],
    },
    {
        value: 'ERP/CRM/SCM',
        label: 'ERP/CRM/SCM',
        sousCategories: [
            {
                value: 'allSubCategoriesErpCrmScm',
                label: `ERP/CRM/SCM/${allSubCategories}`
            }
            ,
            {
                value: 'Salesforce Consultants ',
                label: 'Salesforce Consultants '
            }
            ,
            {
                value: 'Microsoft Dynamics Consultants ',
                label: 'Microsoft Dynamics Consultants '
            }
            ,
            {
                value: 'JD Edwards Consultants ',
                label: 'JD Edwards Consultants '
            }
            ,
            {
                value: 'Oracle Siebel CRM Consultants ',
                label: 'Oracle Siebel CRM Consultants '
            }
            ,
            {
                value: 'Lawson Consultants ',
                label: 'Lawson Consultants '
            }
            ,
            {
                value: 'Oracle Hyperion Consultants ',
                label: 'Oracle Hyperion Consultants '
            }
            ,
            {
                value: 'WMS Consultant ',
                label: 'WMS Consultant '
            }
            ,
            {
                value: 'CiviCRM Consultants',
                label: 'CiviCRM Consultants'
            }
            ,
            {
                value: 'Others',
                label: 'Others'
            }
            ,
        ],
    },
    {
        value: 'IA',
        label: 'IA',
        sousCategories: [
            {
                value: 'allSubCategoriesIA',
                label: `IA/${allSubCategories}`
            }
            ,
            {
                value: 'Data Miners ',
                label: 'Data Miners '
            }
            ,
            {
                value: 'IA Developers ',
                label: 'IA Developers '
            }
            ,
            {
                value: 'Data Analysts ',
                label: 'Data Analysts '
            }
            ,
            {
                value: 'Data Scientists ',
                label: 'Data Scientists '
            }
            ,
            {
                value: 'Project Managers',
                label: 'Project Managers'
            }
            ,
            {
                value: 'Others',
                label: 'Others'
            }
            ,
        ],
    },
    {
        value: 'Information Security',
        label: 'Information Security',
        sousCategories: [
            {
                value: 'allSubCategoriesInformationSecurity',
                label: `Information Security/${allSubCategories}`
            }
            ,
            {
                value: 'Cybersecurity Director ',
                label: 'Cybersecurity Director '
            }
            ,
            {
                value: 'Security coordinator ',
                label: 'Security coordinator '
            }
            ,
            {
                value: 'Safety Program Manager ',
                label: 'Safety Program Manager '
            }
            ,
            {
                value: 'Security project manager ',
                label: 'Security project manager '
            }
            ,
            {
                value: 'Security architect ',
                label: 'Security architect '
            }
            ,
            {
                value: 'Security development specialist ',
                label: 'Security development specialist '
            }
            ,
            {
                value: 'Technical Security Auditor ',
                label: 'Technical Security Auditor '
            }
            ,
            {
                value: 'Cryptologists',
                label: 'Cryptologists'
            }
            ,
            {
                value: 'Cybersecurity Consultants ',
                label: 'Cybersecurity Consultants '
            }
            ,
            {
                value: 'Security Solutions Developers ',
                label: 'Security Solutions Developers '
            }
            ,
            {
                value: 'Cybersecurity Threat Analysts',
                label: 'Cybersecurity Threat Analysts'
            }
            ,
            {
                value: 'Others',
                label: 'Others'
            }
            ,
        ],
    },
];

export const countries = [
    { code: 'AD', label: 'Andorra', phone: '376' },
    { code: 'AE', label: 'United Arab Emirates', phone: '971' },
    { code: 'AF', label: 'Afghanistan', phone: '93' },
    { code: 'AG', label: 'Antigua and Barbuda', phone: '1-268' },
    { code: 'AI', label: 'Anguilla', phone: '1-264' },
    { code: 'AL', label: 'Albania', phone: '355' },
    { code: 'AM', label: 'Armenia', phone: '374' },
    { code: 'AO', label: 'Angola', phone: '244' },
    { code: 'AQ', label: 'Antarctica', phone: '672' },
    { code: 'AR', label: 'Argentina', phone: '54' },
    { code: 'AS', label: 'American Samoa', phone: '1-684' },
    { code: 'AT', label: 'Austria', phone: '43' },
    { code: 'AU', label: 'Australia', phone: '61',
        suggested: true,
    },
    { code: 'AW', label: 'Aruba', phone: '297' },
    { code: 'AX', label: 'Alland Islands', phone: '358' },
    { code: 'AZ', label: 'Azerbaijan', phone: '994' },
    {
        code: 'BA',
        label: 'Bosnia and Herzegovina',
        phone: '387',
    },
    { code: 'BB', label: 'Barbados', phone: '1-246' },
    { code: 'BD', label: 'Bangladesh', phone: '880' },
    { code: 'BE', label: 'Belgium', phone: '32' },
    { code: 'BF', label: 'Burkina Faso', phone: '226' },
    { code: 'BG', label: 'Bulgaria', phone: '359' },
    { code: 'BH', label: 'Bahrain', phone: '973' },
    { code: 'BI', label: 'Burundi', phone: '257' },
    { code: 'BJ', label: 'Benin', phone: '229' },
    { code: 'BL', label: 'Saint Barthelemy', phone: '590' },
    { code: 'BM', label: 'Bermuda', phone: '1-441' },
    { code: 'BN', label: 'Brunei Darussalam', phone: '673' },
    { code: 'BO', label: 'Bolivia', phone: '591' },
    { code: 'BR', label: 'Brazil', phone: '55' },
    { code: 'BS', label: 'Bahamas', phone: '1-242' },
    { code: 'BT', label: 'Bhutan', phone: '975' },
    { code: 'BV', label: 'Bouvet Island', phone: '47' },
    { code: 'BW', label: 'Botswana', phone: '267' },
    { code: 'BY', label: 'Belarus', phone: '375' },
    { code: 'BZ', label: 'Belize', phone: '501' },
    {
        code: 'CA',
        label: 'Canada',
        phone: '1',
        suggested: true,
    },
    {
        code: 'CC',
        label: 'Cocos (Keeling) Islands',
        phone: '61',
    },
    {
        code: 'CD',
        label: 'Congo, Democratic Republic of the',
        phone: '243',
    },
    {
        code: 'CF',
        label: 'Central African Republic',
        phone: '236',
    },
    {
        code: 'CG',
        label: 'Congo, Republic of the',
        phone: '242',
    },
    { code: 'CH', label: 'Switzerland', phone: '41' },
    { code: 'CI', label: 'Cote d\'Ivoire', phone: '225' },
    { code: 'CK', label: 'Cook Islands', phone: '682' },
    { code: 'CL', label: 'Chile', phone: '56' },
    { code: 'CM', label: 'Cameroon', phone: '237' },
    { code: 'CN', label: 'China', phone: '86' },
    { code: 'CO', label: 'Colombia', phone: '57' },
    { code: 'CR', label: 'Costa Rica', phone: '506' },
    { code: 'CU', label: 'Cuba', phone: '53' },
    { code: 'CV', label: 'Cape Verde', phone: '238' },
    { code: 'CW', label: 'Curacao', phone: '599' },
    { code: 'CX', label: 'Christmas Island', phone: '61' },
    { code: 'CY', label: 'Cyprus', phone: '357' },
    { code: 'CZ', label: 'Czech Republic', phone: '420' },
    {
        code: 'DE',
        label: 'Germany',
        phone: '49',
        suggested: true,
    },
    { code: 'DJ', label: 'Djibouti', phone: '253' },
    { code: 'DK', label: 'Denmark', phone: '45' },
    { code: 'DM', label: 'Dominica', phone: '1-767' },
    {
        code: 'DO',
        label: 'Dominican Republic',
        phone: '1-809',
    },
    { code: 'DZ', label: 'Algeria', phone: '213' },
    { code: 'EC', label: 'Ecuador', phone: '593' },
    { code: 'EE', label: 'Estonia', phone: '372' },
    { code: 'EG', label: 'Egypt', phone: '20' },
    { code: 'EH', label: 'Western Sahara', phone: '212' },
    { code: 'ER', label: 'Eritrea', phone: '291' },
    { code: 'ES', label: 'Spain', phone: '34' },
    { code: 'ET', label: 'Ethiopia', phone: '251' },
    { code: 'FI', label: 'Finland', phone: '358' },
    { code: 'FJ', label: 'Fiji', phone: '679' },
    {
        code: 'FK',
        label: 'Falkland Islands (Malvinas)',
        phone: '500',
    },
    {
        code: 'FM',
        label: 'Micronesia, Federated States of',
        phone: '691',
    },
    { code: 'FO', label: 'Faroe Islands', phone: '298' },
    {
        code: 'FR',
        label: 'France',
        phone: '33',
        suggested: true,
    },
    { code: 'GA', label: 'Gabon', phone: '241' },
    { code: 'GB', label: 'United Kingdom', phone: '44' },
    { code: 'GD', label: 'Grenada', phone: '1-473' },
    { code: 'GE', label: 'Georgia', phone: '995' },
    { code: 'GF', label: 'French Guiana', phone: '594' },
    { code: 'GG', label: 'Guernsey', phone: '44' },
    { code: 'GH', label: 'Ghana', phone: '233' },
    { code: 'GI', label: 'Gibraltar', phone: '350' },
    { code: 'GL', label: 'Greenland', phone: '299' },
    { code: 'GM', label: 'Gambia', phone: '220' },
    { code: 'GN', label: 'Guinea', phone: '224' },
    { code: 'GP', label: 'Guadeloupe', phone: '590' },
    { code: 'GQ', label: 'Equatorial Guinea', phone: '240' },
    { code: 'GR', label: 'Greece', phone: '30' },
    {
        code: 'GS',
        label: 'South Georgia and the South Sandwich Islands',
        phone: '500',
    },
    { code: 'GT', label: 'Guatemala', phone: '502' },
    { code: 'GU', label: 'Guam', phone: '1-671' },
    { code: 'GW', label: 'Guinea-Bissau', phone: '245' },
    { code: 'GY', label: 'Guyana', phone: '592' },
    { code: 'HK', label: 'Hong Kong', phone: '852' },
    {
        code: 'HM',
        label: 'Heard Island and McDonald Islands',
        phone: '672',
    },
    { code: 'HN', label: 'Honduras', phone: '504' },
    { code: 'HR', label: 'Croatia', phone: '385' },
    { code: 'HT', label: 'Haiti', phone: '509' },
    { code: 'HU', label: 'Hungary', phone: '36' },
    { code: 'ID', label: 'Indonesia', phone: '62' },
    { code: 'IE', label: 'Ireland', phone: '353' },
    { code: 'IL', label: 'Israel', phone: '972' },
    { code: 'IM', label: 'Isle of Man', phone: '44' },
    { code: 'IN', label: 'India', phone: '91' },
    {
        code: 'IO',
        label: 'British Indian Ocean Territory',
        phone: '246',
    },
    { code: 'IQ', label: 'Iraq', phone: '964' },
    {
        code: 'IR',
        label: 'Iran, Islamic Republic of',
        phone: '98',
    },
    { code: 'IS', label: 'Iceland', phone: '354' },
    { code: 'IT', label: 'Italy', phone: '39' },
    { code: 'JE', label: 'Jersey', phone: '44' },
    { code: 'JM', label: 'Jamaica', phone: '1-876' },
    { code: 'JO', label: 'Jordan', phone: '962' },
    {
        code: 'JP',
        label: 'Japan',
        phone: '81',
        suggested: true,
    },
    { code: 'KE', label: 'Kenya', phone: '254' },
    { code: 'KG', label: 'Kyrgyzstan', phone: '996' },
    { code: 'KH', label: 'Cambodia', phone: '855' },
    { code: 'KI', label: 'Kiribati', phone: '686' },
    { code: 'KM', label: 'Comoros', phone: '269' },
    {
        code: 'KN',
        label: 'Saint Kitts and Nevis',
        phone: '1-869',
    },
    {
        code: 'KP',
        label: 'Korea, Democratic People\'s Republic of',
        phone: '850',
    },
    { code: 'KR', label: 'Korea, Republic of', phone: '82' },
    { code: 'KW', label: 'Kuwait', phone: '965' },
    { code: 'KY', label: 'Cayman Islands', phone: '1-345' },
    { code: 'KZ', label: 'Kazakhstan', phone: '7' },
    {
        code: 'LA',
        label: 'Lao People\'s Democratic Republic',
        phone: '856',
    },
    { code: 'LB', label: 'Lebanon', phone: '961' },
    { code: 'LC', label: 'Saint Lucia', phone: '1-758' },
    { code: 'LI', label: 'Liechtenstein', phone: '423' },
    { code: 'LK', label: 'Sri Lanka', phone: '94' },
    { code: 'LR', label: 'Liberia', phone: '231' },
    { code: 'LS', label: 'Lesotho', phone: '266' },
    { code: 'LT', label: 'Lithuania', phone: '370' },
    { code: 'LU', label: 'Luxembourg', phone: '352' },
    { code: 'LV', label: 'Latvia', phone: '371' },
    { code: 'LY', label: 'Libya', phone: '218' },
    { code: 'MA', label: 'Morocco', phone: '212' },
    { code: 'MC', label: 'Monaco', phone: '377' },
    {
        code: 'MD',
        label: 'Moldova, Republic of',
        phone: '373',
    },
    { code: 'ME', label: 'Montenegro', phone: '382' },
    {
        code: 'MF',
        label: 'Saint Martin (French part)',
        phone: '590',
    },
    { code: 'MG', label: 'Madagascar', phone: '261' },
    { code: 'MH', label: 'Marshall Islands', phone: '692' },
    {
        code: 'MK',
        label: 'Macedonia, the Former Yugoslav Republic of',
        phone: '389',
    },
    { code: 'ML', label: 'Mali', phone: '223' },
    { code: 'MM', label: 'Myanmar', phone: '95' },
    { code: 'MN', label: 'Mongolia', phone: '976' },
    { code: 'MO', label: 'Macao', phone: '853' },
    {
        code: 'MP',
        label: 'Northern Mariana Islands',
        phone: '1-670',
    },
    { code: 'MQ', label: 'Martinique', phone: '596' },
    { code: 'MR', label: 'Mauritania', phone: '222' },
    { code: 'MS', label: 'Montserrat', phone: '1-664' },
    { code: 'MT', label: 'Malta', phone: '356' },
    { code: 'MU', label: 'Mauritius', phone: '230' },
    { code: 'MV', label: 'Maldives', phone: '960' },
    { code: 'MW', label: 'Malawi', phone: '265' },
    { code: 'MX', label: 'Mexico', phone: '52' },
    { code: 'MY', label: 'Malaysia', phone: '60' },
    { code: 'MZ', label: 'Mozambique', phone: '258' },
    { code: 'NA', label: 'Namibia', phone: '264' },
    { code: 'NC', label: 'New Caledonia', phone: '687' },
    { code: 'NE', label: 'Niger', phone: '227' },
    { code: 'NF', label: 'Norfolk Island', phone: '672' },
    { code: 'NG', label: 'Nigeria', phone: '234' },
    { code: 'NI', label: 'Nicaragua', phone: '505' },
    { code: 'NL', label: 'Netherlands', phone: '31' },
    { code: 'NO', label: 'Norway', phone: '47' },
    { code: 'NP', label: 'Nepal', phone: '977' },
    { code: 'NR', label: 'Nauru', phone: '674' },
    { code: 'NU', label: 'Niue', phone: '683' },
    { code: 'NZ', label: 'New Zealand', phone: '64' },
    { code: 'OM', label: 'Oman', phone: '968' },
    { code: 'PA', label: 'Panama', phone: '507' },
    { code: 'PE', label: 'Peru', phone: '51' },
    { code: 'PF', label: 'French Polynesia', phone: '689' },
    { code: 'PG', label: 'Papua New Guinea', phone: '675' },
    { code: 'PH', label: 'Philippines', phone: '63' },
    { code: 'PK', label: 'Pakistan', phone: '92' },
    { code: 'PL', label: 'Poland', phone: '48' },
    {
        code: 'PM',
        label: 'Saint Pierre and Miquelon',
        phone: '508',
    },
    { code: 'PN', label: 'Pitcairn', phone: '870' },
    { code: 'PR', label: 'Puerto Rico', phone: '1' },
    {
        code: 'PS',
        label: 'Palestine, State of',
        phone: '970',
    },
    { code: 'PT', label: 'Portugal', phone: '351' },
    { code: 'PW', label: 'Palau', phone: '680' },
    { code: 'PY', label: 'Paraguay', phone: '595' },
    { code: 'QA', label: 'Qatar', phone: '974' },
    { code: 'RE', label: 'Reunion', phone: '262' },
    { code: 'RO', label: 'Romania', phone: '40' },
    { code: 'RS', label: 'Serbia', phone: '381' },
    { code: 'RU', label: 'Russian Federation', phone: '7' },
    { code: 'RW', label: 'Rwanda', phone: '250' },
    { code: 'SA', label: 'Saudi Arabia', phone: '966' },
    { code: 'SB', label: 'Solomon Islands', phone: '677' },
    { code: 'SC', label: 'Seychelles', phone: '248' },
    { code: 'SD', label: 'Sudan', phone: '249' },
    { code: 'SE', label: 'Sweden', phone: '46' },
    { code: 'SG', label: 'Singapore', phone: '65' },
    { code: 'SH', label: 'Saint Helena', phone: '290' },
    { code: 'SI', label: 'Slovenia', phone: '386' },
    {
        code: 'SJ',
        label: 'Svalbard and Jan Mayen',
        phone: '47',
    },
    { code: 'SK', label: 'Slovakia', phone: '421' },
    { code: 'SL', label: 'Sierra Leone', phone: '232' },
    { code: 'SM', label: 'San Marino', phone: '378' },
    { code: 'SN', label: 'Senegal', phone: '221' },
    { code: 'SO', label: 'Somalia', phone: '252' },
    { code: 'SR', label: 'Suriname', phone: '597' },
    { code: 'SS', label: 'South Sudan', phone: '211' },
    {
        code: 'ST',
        label: 'Sao Tome and Principe',
        phone: '239',
    },
    { code: 'SV', label: 'El Salvador', phone: '503' },
    {
        code: 'SX',
        label: 'Sint Maarten (Dutch part)',
        phone: '1-721',
    },
    {
        code: 'SY',
        label: 'Syrian Arab Republic',
        phone: '963',
    },
    { code: 'SZ', label: 'Swaziland', phone: '268' },
    {
        code: 'TC',
        label: 'Turks and Caicos Islands',
        phone: '1-649',
    },
    { code: 'TD', label: 'Chad', phone: '235' },
    {
        code: 'TF',
        label: 'French Southern Territories',
        phone: '262',
    },
    { code: 'TG', label: 'Togo', phone: '228' },
    { code: 'TH', label: 'Thailand', phone: '66' },
    { code: 'TJ', label: 'Tajikistan', phone: '992' },
    { code: 'TK', label: 'Tokelau', phone: '690' },
    { code: 'TL', label: 'Timor-Leste', phone: '670' },
    { code: 'TM', label: 'Turkmenistan', phone: '993' },
    { code: 'TN', label: 'Tunisia', phone: '216' },
    { code: 'TO', label: 'Tonga', phone: '676' },
    { code: 'TR', label: 'Turkey', phone: '90' },
    {
        code: 'TT',
        label: 'Trinidad and Tobago',
        phone: '1-868',
    },
    { code: 'TV', label: 'Tuvalu', phone: '688' },
    {
        code: 'TW',
        label: 'Taiwan, Republic of China',
        phone: '886',
    },
    {
        code: 'TZ',
        label: 'United Republic of Tanzania',
        phone: '255',
    },
    { code: 'UA', label: 'Ukraine', phone: '380' },
    { code: 'UG', label: 'Uganda', phone: '256' },
    {
        code: 'US',
        label: 'United States',
        phone: '1',
        suggested: true,
    },
    { code: 'UY', label: 'Uruguay', phone: '598' },
    { code: 'UZ', label: 'Uzbekistan', phone: '998' },
    {
        code: 'VA',
        label: 'Holy See (Vatican City State)',
        phone: '379',
    },
    {
        code: 'VC',
        label: 'Saint Vincent and the Grenadines',
        phone: '1-784',
    },
    { code: 'VE', label: 'Venezuela', phone: '58' },
    {
        code: 'VG',
        label: 'British Virgin Islands',
        phone: '1-284',
    },
    {
        code: 'VI',
        label: 'US Virgin Islands',
        phone: '1-340',
    },
    { code: 'VN', label: 'Vietnam', phone: '84' },
    { code: 'VU', label: 'Vanuatu', phone: '678' },
    { code: 'WF', label: 'Wallis and Futuna', phone: '681' },
    { code: 'WS', label: 'Samoa', phone: '685' },
    { code: 'XK', label: 'Kosovo', phone: '383' },
    { code: 'YE', label: 'Yemen', phone: '967' },
    { code: 'YT', label: 'Mayotte', phone: '262' },
    { code: 'ZA', label: 'South Africa', phone: '27' },
    { code: 'ZM', label: 'Zambia', phone: '260' },
    { code: 'ZW', label: 'Zimbabwe', phone: '263' },
];

export const STATUS_CRA = {
    pending: 'pending', // ? 'En attente de validation',
    NV: 'NV', // ? 'Non validé',
    //* TODO I must change those value to reasonable ones
    VE: 'VE', // ? 'Validé par l\'expert',
    VC: 'VC', // ? 'Validé par le client',
    NULL: 'NULL'
};

const STATUS_CRA_Labels = {
    NV: {
        value: 'NV', // ? 'Non validé',
        label: 'Rejeté'
    },
    pending: {
        // ? 'En attente de validation',
        value: 'pending',
        label: 'En attente validation-Expert'
    },
    VE: { value: 'VE', label:  'En attente validation-Client' }, // * Validé par l\'expert', }, // * == en attente validation Client
    VC: { value: 'VC', label: 'Validé', }, // * == Validé par le client
    NULL: { value: 'VC', label: 'CRA NUL', },
};

export function getStatusCraLabel(status) {
    return (STATUS_CRA_Labels[status]?.label)?? '';
}

export const secteurActiviteEnum = [
    // we can use labels only, since we have too much values, and they are not critical
    { label: 'Aérospatiale', value: 'aerospatiale' },
    { label: 'Alimentation santé', value: 'alimentationSante' },
    { label: 'Ameublement', value: 'ameublement' },
    { label: 'Appareils médicaux et instruments scientifiques', value: 'appareilsMedicauxEtInstrumentsScientifiques' },
    { label: 'Assurances', value: 'assurances' },
    { label: 'Autres', value: 'autres' },
    { label: 'Biens d\'équipement', value: 'biensEquipement' },
    { label: 'Bioalimentaire', value: 'bioalimentaire' },
    { label: 'Biotechnologies', value: 'biotechnologies' },
    { label: 'Centre de contacts clients', value: 'centreDeContactsClients' },
    { label: 'Centre de données et services connexes', value: 'centreDeDonneesEtServicesConnexes' },
    { label: 'Chimie', value: 'chimie' },
    { label: 'Commerce de détail et de gros', value: 'commerceDeDetailEtDeGros' },
    { label: 'Construction et ingénierie', value: 'constructionEtIngenierie' },
    { label: 'Cybersécurité', value: 'cybersecurite' },
    { label: 'Effets visuels et animation', value: 'effetsVisuelsEtAnimation' },
    { label: 'Énergies renouvelables', value: 'energiesRenouvelables' },
    { label: 'Finance', value: 'finance' },
    { label: 'Instrumentation test et mesures', value: 'instrumentationTestEtMesures' },
    { label: 'Jeux vidéo', value: 'jeuxVideo' },
    { label: 'Logiciel', value: 'logiciel' },
    { label: 'Logistique et transport', value: 'logistiqueEtTransport' },
    { label: 'Matériaux avancés', value: 'materiauxAvances' },
    { label: 'Métallurgie', value: 'metallurgie' },
    { label: 'Minéraux', value: 'mineraux' },
    { label: 'Optique photonique', value: 'optiquePhotonique' },
    { label: 'Pétrochimie', value: 'petrochimie' },
    { label: 'Pharmaceutiques', value: 'pharmaceutiques' },
    { label: 'Plasturgie', value: 'plasturgie' },
    { label: 'Production cinématographique', value: 'productionCinematographique' },
    { label: 'Produits forestiers', value: 'produitsForestiers' },
    { label: 'Récréotouristique', value: 'recreatotouristique' },
    { label: 'Santé numérique', value: 'santeNumrique' },
    { label: 'Science et analyse de données', value: 'scienceEtAnalyseDeDonnees' },
    { label: 'Sécurité et défense', value: 'securiteEtDefense' },
    { label: 'Services administratifs', value: 'servicesAdministratifs' },
    { label: 'Services d\'affaires', value: 'servicesDAffaires' },
    { label: 'Services d\'enseignement', value: 'servicesDEnseignement' },
    { label: 'Services d\'hébergements et de restauration', value: 'servicesDHebergementsEtDeRestauration' },
    { label: 'Services de santé', value: 'servicesDeSante' },
    { label: 'Services environnementaux', value: 'servicesEnvironnementaux' },
    { label: 'Services informatiques', value: 'servicesInformatiques' },
    { label: 'Services techniques', value: 'servicesTechniques' },
    { label: 'Télécommunications', value: 'telecommunications' },
    { label: 'Textile et vêtements', value: 'textileEtVetements' },
    { label: 'Transport maritime', value: 'transportMaritime' },
    { label: 'Transport terrestre (sauf véhicules électrique)', value: 'transportTerrestreSaufVehiculesElectrique' },
    { label: 'Véhicule électrique', value: 'vehiculeElectrique' }
];